<template>
  <vs-popup class="customer-sample-order-create-popup"
            title="RM ORDER CREATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card id="popup" no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(openSaveConfirm)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
                  <vs-table :data="cartItems">
                    <template slot="header">
                      <h3>

                      </h3>
                    </template>
                    <template slot="thead">
                      <vs-th width="10%">ITS PRODUCT CODE</vs-th>
                      <vs-th width="15%">ITS PRODUCT NAME</vs-th>
                      <vs-th width="20%">SITE ADDRESS</vs-th>
                      <vs-th width="15%">SUPPLIER</vs-th>
                      <vs-th width="5%">CURRENCY CODE</vs-th>
                      <vs-th width="5%">UNIT</vs-th>
                      <vs-th width="5%">QUANTITY</vs-th>
                      <vs-th width="10%">UNIT PRICE</vs-th>
                      <vs-th width="10%">TOTAL PRICE</vs-th>
                      <vs-th width="5%"></vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].company_product_code">
                          {{ data[indextr].category }}-{{ data[indextr].company_product_code }}
                        </vs-td>
                        <vs-td :data="data[indextr].company_product_name">
                          {{ data[indextr].company_product_name }}
                        </vs-td>

                        <vs-td>
                          <ValidationProvider :vid="`site_adress${indextr}`" :name="`site_adress${indextr}`" rules="required" v-slot="{ errors }">
                          <v-select :filter-by="myFilter" :clearable="false"
                                    name="country" placeholder=""
                                    label="site_name" v-model="data[indextr].site_adress"
                                    :options="data[indextr].supplier_site_addresses.filter((x) => x.is_approved === 2)" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                            <span class="text-danger text-sm">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </vs-td>

                        <vs-td :data="data[indextr].supplier">
                          {{ data[indextr].supplier }}
                        </vs-td>

                        <vs-td :data="data[indextr].currency_code">
                          {{ data[indextr].currency_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].unit">
                          {{ data[indextr].unit }}
                        </vs-td>

                        <vs-td :data="data[indextr].quantity">
                          {{ data[indextr].quantity }}
                        </vs-td>

                        <vs-td :data="data[indextr].price">
                          {{ data[indextr].price }}
                        </vs-td>

                        <vs-td :data="data[indextr].price">
                          {{data[indextr].quantity ? (Number(data[indextr].price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                        </vs-td>


                        <vs-td :data="data[indextr].id">
                          <vx-tooltip class="" text="Remove from cart" position="left">
                            <vs-button @click="onClickRemoveFromCart(data[indextr].id)"
                                       size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                          </vx-tooltip>
                        </vs-td>

                      </vs-tr>
                      <vs-tr>
                        <vs-td colspan="8" style="font-weight: bolder">Total</vs-td>
                        <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>
                        <vs-td></vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>
            </div>
          </div>
          <div class="vx-row mb-3" v-if="checkAllItemsInSameSupplier">
            <div class="vx-col md:w-full w-full md:mb-0">
                <vx-card no-shadow title="Additional Cost" cardBorder>
                  <div class="vx-row mb-3" v-for="(cost, cost_index) in form.additional_costs" :key="cost_index">
                  <div class="vx-col md:w-2/5 w-full md:mb-0">
                    <ValidationProvider :vid="cost_index+'name'" :name="cost_index+'name'" rules="required" v-slot="{ errors }">
                      <small class="label">Details</small>
                      <vs-input v-model="cost.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-2/5 w-full md:mb-0">
                    <ValidationProvider :vid="cost_index+'amount'" :name="cost_index+'amount'" rules="required" v-slot="{ errors }">
                      <small class="label">Value(GBP)</small>
                      <vs-input v-model="cost.amount"  name="amount" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/5 w-full md:mb-0">
                    <small class="label">&nbsp;</small>
                    <vs-button @click.stop="deleteCost(cost_index)" size="small" color="danger" class="mt-2 ml-4">Remove</vs-button>
                  </div>
                </div>
                <div class="vx-row">
                  <vs-button @click.stop="addCost" size="small" class="mt-4 ml-4">+ Add</vs-button>
                </div>
              </vx-card>
              </div>
              </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <vx-card no-shadow title="Delivery Address to be Used" cardBorder>
                <div class="vx-row mb-8">
                  <div class="vx-col w-full">
                    <span class="flex">
                      <h5 class="mr-4">Change delivery address to customer address</h5>
                      <vs-switch v-model="use_customer_delivery_address"/>
                    </span>
                  </div>
                </div>
                <span v-if="use_customer_delivery_address">
                  <div class="vx-row mb-3">
                    <div class="vx-col w-full">
                      <customer-dropdown v-on:onInput="onSelectCustomerDropdown" :field_label="'Customer'" /> 
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="delivery_address" name="delivery_address" rules="required" v-slot="{ errors }">
                        <small class="label">Select a delivery address</small>
                        <v-select
                          v-on:input="onChangeSelectDeliveryAddress"
                          name="delivery_address" placeholder=""
                          v-model="form.delivery_address" :reduce="option => option"
                          label="country"
                          :options="customer_addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                          <template slot="option" slot-scope="option">
                            <div class="d-center">
                              <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                              <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                              <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                              <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                              <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                              <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                              <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                            </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                              <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                              <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                              <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                              <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                              <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                              <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                              <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                            </div>
                          </template>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                    <div class="vx-col w-full">
                      <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                        <small class="label">Note</small>
                        <vs-textarea class="mb-0" v-model="form.delivery_address.note" height="50px" />
                        <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </span>
                <span v-else>
                  <div class="vx-row mb-3 mt-4">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 1</small>
                      <vs-input readonly v-model="form.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 2</small>
                      <vs-input readonly v-model="form.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input readonly v-model="form.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town / State</small>
                      <vs-input readonly v-model="form.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input readonly v-model="form.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select disabled :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="form.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                </span>
              </vx-card>
              <vx-card no-shadow cardBorder class="mt-4">
                 <div class="vx-row mb-3">
                   <div class="vx-col md:w-1/4 w-full md:mb-0">
                    <ValidationProvider vid="required_by" name="required_by" rules="required" v-slot="{ errors }">
                      <small class="label">Required By Date</small>
                      <flat-pickr class="w-full"
                                  style="display: none"
                                  :config="{ dateFormat: 'd/m/Y'}"
                                  v-model="form.required_by"
                                  placeholder="Choose Date"
                      />
                      <flat-pickr class="w-full"
                                  :config="{ dateFormat: 'd/m/Y'}"
                                  v-model="form.required_by"
                                  placeholder="Choose Date"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                   <div class="vx-col md:w-1/4 w-full md:mb-0">
                    <ValidationProvider vid="sage_department" name="sage_department" rules="required" v-slot="{errors}">
                      <small class="label">Sage Department</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="sage_department" placeholder=""
                                label="name" v-model="form.sage_department_id" :reduce="option => option.id"
                                :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/4 w-full md:mb-0">
                    <ValidationProvider vid="sage_nominal_code_id" name="sage_nominal_code_id" rules="required" v-slot="{errors}">
                      <small class="label">Sage Nominal Code</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="sage_nominal_code_id" placeholder=""
                                label="name" v-model="form.sage_nominal_code_id" :reduce="option => option.id"
                                :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                   </div>
                   <div class="vx-col md:w-1/4 w-full md:mb-0">
                    <ValidationProvider vid="region" name="region" rules="required" v-slot="{errors}">
                      <small class="label">Region</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="region" placeholder=""
                                label="name" v-model="form.region_id" :reduce="option => option.id"
                                :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                   </div>
                 </div>

                <div class="vx-row mb-3">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                      <small class="label">Delivery Instructions</small>
                      <vs-textarea class="mb-0" v-model="form.delivery_instruction" height="100px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="vx-row mb-3">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                      <small class="label">Note</small>
                      <vs-textarea class="mb-0" v-model="form.note" height="100px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

              </vx-card>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Order</vs-button>
            <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import SageFactory from "@/mixins/SageFactory";
  import flatPickr from 'vue-flatpickr-component'
  import CustomerDropdown from "@/components/drop-down-filters/CustomerDropdown";

  const CustomerRepository = RepositoryFactory.get('customer')
  const InventoryRepository = RepositoryFactory.get('inventory')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const SettingsRepository = RepositoryFactory.get('settings');
  const RegionsRepository = RepositoryFactory.get('regions');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');
  const CompanyAddressRepository = RepositoryFactory.get('company_address');

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction: '',
        note: '',
        raw_material_items: [],
        required_by:'',
        delivery_address: {
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: '',
          note: '',
        },
        additional_costs:[]
      },
      selectedDeliveryAddress: {},
      countryCodes: [],
      cartItems: [],
      onClickAddressChange: true,
      sage_departments: [],
      regions: [],
      sage_nominal_codes: [],
      use_customer_delivery_address: false,
      customer_addresses: [],
    }
  }

export default {
  name: 'CreateRmOrderPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        await this.getCountryCodes()
        await this.getItemsInItemsCart()
        await this.fetchSettings()
        await this.getSageDepartments()
        await this.getSageNominalCodes()
        await this.getRegions()
        this.open = true;
      } catch (error) {

      }
    },
    async onClickClose() {
      const vue = this;
      this.open = false
      await vue.$parent.onlyRefreshData()
    },
    openSaveConfirm() {
      if (this.checkAllItemsInSameSupplier) {
        this.onClickCreateRmOrder()
      } else {
        this.open = false
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Note',
          acceptText: 'Proceed',
          text: 'This cart has products from more than 1 supplier. A separated PO will be created for each supplier in this order',
          accept: this.onClickCreateRmOrder,
          cancel: this.closeUpdate
        })
      }
    },
    async createSageOrders(params) {
      this.$vs.loading()
      const vue = this;
      await this.createSageProductOrder(params[0])
      this.$vs.loading.close()
      await vue.$parent.refreshData()
    },
    closeUpdate() {
      this.open = true
    },
    addCost(){
      this.form.additional_costs.push({ name: '',amount:''});
    },
     deleteCost: function (index) {
       this.form.additional_costs.splice(index, 1);
    },
    async onClickCreateRmOrder () {
      const vue = this;
      this.$vs.loading()
      let order_data = []
       try {
         const payload = this.form

         payload.raw_material_items = this.cartItems.map((n) => {
           return {
             id: n.supplier_raw_material_id,
             price: n.price,
             quantity: n.quantity,
             gbp_price: n.gbp_price,
             site_address: {
               site_id : n.site_adress.id,
               supplier_id : n.site_adress.supplier_id,
               supplier_site_name : n.site_adress.site_name,
               supplier_line1 : n.site_adress.address_line1,
               supplier_line2 : n.site_adress.address_line2,
               supplier_line3 : n.site_adress.address_line3,
               supplier_town_state : n.site_adress.address_town_state,
               supplier_post_code : n.site_adress.address_post_code,
               supplier_country : n.site_adress.address_country,
             }
           }
         })
         this.form.additional_costs = this.form.additional_costs.map((x) => { 
            return { name: x.name, amount: Number(x.amount).toFixed(2), supplier_id: [this.supplier_id_in_single_supplier_order] }
          })
         if(!this.use_customer_delivery_address) {
            payload.delivery_address = {
              name: this.form.name,
              line1: this.form.line1,
              line2: this.form.line2,
              line3: this.form.line3,
              town_state: this.form.town_state,
              post_code: this.form.post_code,
              country: this.form.country,
              note: this.form.note
            }
         }
         order_data = (await InventoryRepository.createRmOrder(payload)).data.data
         this.showSuccessMessage('Raw Material order created successfully')
         this.open = false;
         // await vue.$parent.refreshData()
       }catch (e) {
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
      if(!this.$can('create-edit-sage-purchase-order')) {
        return
      }
      const ordersWithoutSageId = order_data.filter((order) => order.sage_supplier_id === "")
      if(ordersWithoutSageId.length === 0){
        await this.createSageOrders([order_data])
      }else{
        const text = `The following supplier(s) is not set up on sage. If you proceed you will need to manually synchronise
        all orders from this purchase OR activate that supplier in sage. Order ID: ${ordersWithoutSageId.map((order)=> order.order_code+' ')}`
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Note',
          acceptText: 'Proceed',
          text: text,
          accept: this.createSageOrders,
          parameters: [order_data],
          cancel: this.closeUpdate
        })
      }
    },
    async getCountryCodes() {
      this.$vs.loading()
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async getItemsInItemsCart() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        const {data} = (await InventoryRepository.getRmOrderCartList()).data
        this.cartItems = data
        this.cartItems.map((item,index) => {
          if(item.supplier_site_addresses.filter((x) => x.is_approved === 2).length === 1){
            item.site_adress = item.supplier_site_addresses.find((x) => x.is_approved === 2)
          }
        })
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async fetchSettings(){
      this.$vs.loading()

      try {
        const settings = (await SettingsRepository.getTheItem('order_delivery_instructions')).data.data
        this.form.delivery_instruction = settings.order_delivery_instructions

        const { data: addresses } = (await CompanyAddressRepository.getCompanyAddresses('filter[is_default]=1')).data
        const defaultAddress = addresses[0]
        if (defaultAddress) {
          this.form.name = defaultAddress.name || ''
          this.form.line1 = defaultAddress.line1 || ''
          this.form.line2 = defaultAddress.line2 || ''
          this.form.line3 = defaultAddress.line3 || ''
          this.form.town_state = defaultAddress.town_state || ''
          this.form.post_code = defaultAddress.post_code || ''
          this.form.country = defaultAddress.country || ''
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }

      this.$vs.loading.close()
    },
    async getSageDepartments(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
      this.sage_departments =  data.data
      this.$vs.loading.close()
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },
    async getRegions(){
      this.$vs.loading()
      const {data} = await RegionsRepository.getListOfRegions()
      this.regions =  data.data
      this.$vs.loading.close()
    },
    async onClickRemoveFromCart(id) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        await InventoryRepository.removeRmFromCart(id)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Removed from cart')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    totalCalculator() {
      let total = 0;
      this.cartItems.forEach((m) => {
        if (!!m.price) {
          total = total + Number(m.price) * Number(m.quantity)
        }
      })
      return total.toFixed(2)
    },
    async onSelectCustomerDropdown(data) {
      this.customer_addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(data.id)).data.data;
    },
    onChangeSelectDeliveryAddress(selected) {
      this.form.delivery_address.name = selected.name
      this.form.delivery_address.line1 = selected.line1
      this.form.delivery_address.line2 = selected.line2
      this.form.delivery_address.line3 = selected.line3
      this.form.delivery_address.town_state = selected.town_state
      this.form.delivery_address.post_code = selected.post_code
      this.form.delivery_address.country = selected.country
      this.form.delivery_address.note = selected.additional_info || selected.notes
    },
  },

  computed: {
    checkAllItemsInSameSupplier: function () {
      const suppliers = this.cartItems.map((n) => n.supplier)
      return suppliers.every( (val, i, arr) => val === arr[0] )
    },
    supplier_id_in_single_supplier_order: function () {
      if(this.cartItems.length === 0) return null
      return this.cartItems[0].supplier_id
    }
  },
  components: {
    'v-select': vSelect,
    flatPickr,
    CustomerDropdown
  },
  mixins: [SuccessMessage, ErrorMessages, SageFactory],
}
</script>

<style lang="scss">
  .vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    z-index: 1030 !important;
    transform: none;
  }
</style>

<style scoped >
.customer-sample-order-create-popup >>> .vs-popup {
  min-width: 90% !important;
}
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
